module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_zh-hant-557810379fe66b80e74dcbf17fc762dc.jpg";